import ToplistIcon from "@/assets/icons/bolt.svg";
import FireIcon from "@/assets/icons/fire.svg";
import PositiveImpactIcon from "@/assets/icons/heart.svg";
import RocketLaunchIcon from "@/assets/icons/rocket-launch.svg";
import NegativeImpactIcon from "@/assets/icons/shield-exclamation.svg";
import RecordIcon from "@/assets/icons/trophy.svg";
import { INSIGHT_TYPE, INSIGHT_TYPE_TO_LABEL, InsightType } from "@/constants";
import { InsightV4 } from "@/types/MentionCard";
import { Badge, BadgeProps } from "@components/ui/badge";
import { i18n, MessageDescriptor } from "@lingui/core";

type InsightBadgeProps = {
  insight: InsightV4;
};

type InsightBadgeSettings = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  variant: BadgeProps["variant"];
  label: MessageDescriptor;
};

const SETTINGS: Partial<Record<InsightType, InsightBadgeSettings>> = {
  [INSIGHT_TYPE.HIGH_REACH_MENTION]: {
    icon: FireIcon,
    variant: "yellow",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.HIGH_REACH_MENTION],
  },
  [INSIGHT_TYPE.TOPLIST_MENTIONS]: {
    icon: ToplistIcon,
    variant: "fuchsia",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.TOPLIST_MENTIONS],
  },
  [INSIGHT_TYPE.NEGATIVE_IMPACT]: {
    icon: NegativeImpactIcon,
    variant: "red",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.NEGATIVE_IMPACT],
  },
  [INSIGHT_TYPE.POSITIVE_IMPACT]: {
    icon: PositiveImpactIcon,
    variant: "green",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.POSITIVE_IMPACT],
  },
  [INSIGHT_TYPE.MOST_MENTIONS]: {
    icon: RecordIcon,
    variant: "purple",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.MOST_MENTIONS],
  },
  [INSIGHT_TYPE.MORE_MENTIONS_THAN_USUAL]: {
    icon: RocketLaunchIcon,
    variant: "blue",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.MORE_MENTIONS_THAN_USUAL],
  },
  [INSIGHT_TYPE.MORE_CHANNELS_THAN_USUAL]: {
    icon: RocketLaunchIcon,
    variant: "blue",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.MORE_CHANNELS_THAN_USUAL],
  },
  [INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE]: {
    icon: RecordIcon,
    variant: "purple",
    label: INSIGHT_TYPE_TO_LABEL[INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE],
  },
};

export default function InsightBadge({ insight }: InsightBadgeProps) {
  const settings = SETTINGS[insight.type];

  if (!settings) return null;

  const { icon: Icon, variant, label } = settings;

  return (
    <Badge
      data-testid="insight-badge"
      variant={variant}
      shape="square"
      size="lg"
    >
      <Icon className="size-4 shrink-0" />
      {i18n._(label)}
    </Badge>
  );
}
